import http from "../http-common";
import {
  CancelPending,
  loginError,
  loginErrorVerify,
  loginRequest,
  loginSuccess
} from "../redux/Slices/Auth";
import { toast } from "react-toastify";
import axios from "axios";


export const loginUser = (user, dispatch, history) => {
  dispatch(loginRequest());
  let verify = 0;

  http
    .post("admin-login", user)
    .then((response) => {
      if (response.data.authorized) {
        localStorage.setItem("isAuthenticated", true);
        verifyUser(dispatch, history, verify);
      } else {
        toast.error(response.data.message || "Invalid email or password");
        dispatch(loginError());
      }
    })
    .catch((error) => {
      const message =
        error?.response?.data?.message || "Unable to reach the server. Please try again.";
      toast.error(message);
      dispatch(loginError(error));
    });
};

const ADMIN_PANEL_TYPES = ["SuperAdmin", "Admin", "admin", "vendor"];

//From token || localStorage, verify user session.
export const verifyUser = (dispatch, history, verify) => {
  dispatch(loginRequest());

  if (!localStorage.getItem("isAuthenticated")) {
    dispatch(loginError());
    history.replace("/signin");
    return;
  }

  http
    .get("user")
    .then((response) => {
      if (response.data.success) {
        const user = response.data.data;

        if (!ADMIN_PANEL_TYPES.includes(user?.type)) {
          toast.error("You do not have access to the admin dashboard");
          dispatch(loginError());
          history.replace("/signin");
          return;
        }

        dispatch(loginSuccess(user));
        if (!verify) {
          history.push("/");
          toast.success('Login success');
        }
      } else {
        dispatch(loginError());
        history.replace('/signin');
      }
    })
    .catch((error) => {
      const message = error?.response?.data?.message || "Session verification failed";
      toast.error(message);
      dispatch(loginErrorVerify({ error, history }));
    });
};



export const registerVendor = async (vendor, history) => {
  http
    .post(`register-vendor`, vendor)
    .then((response) => {
      if(response.data.success){
        toast.success(response.data.message);
        history.push('/signin');
      }else{
        toast.error(response.data.message);
      }
    })
    .catch((err) => {
      toast.error("Error! Registration fails");
    });
};

export const checkAuth  = async (history) => {
  http.get('authenticated')
  .then((response) => {
    if(response.data.success){
      history.push('/');
      return;
    }
  }).catch((error) => {});
}

